import React from 'react';

import styles from './FAQSection.module.scss';

import questionMarkIcon from '../../public/images/icons/question-mark-circle-icon.svg';

const {
  'faq-section': faqSectionClass,
  questions: questionsClass,
  question: questionClass
} = styles;

const questions = [
  {
    question: 'Can I change my funeral home after purchase?',
    answer:
      'Yes. If you decide you’d like to work with another funeral home down the road, our care team can help you switch. '
  },
  {
    question: 'What are the different payment options available?',
    answer:
      'We offer two different options: you can purchase your package directly or buy insurance with low monthly payments.'
  },
  {
    question: 'Can I return my package if I change my mind?',
    answer:
      'Yes. If you’re not fully satisfied with your purchase within 30 days we’ll issue a full refund, no questions asked.'
  }
];

const FAQSection = ({ questionsArray = questions }) => {
  return (
    <div className={faqSectionClass}>
      <h2>Have a specific question in mind?</h2>
      <div className={questionsClass}>
        {questionsArray.map(question => (
          <div className={questionClass} key={question.question}>
            <img src={questionMarkIcon} />
            <h4>{question.question}</h4>
            <p>{question.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
